import PropTypes from 'prop-types';

import { Accordion } from 'honeydew/Accordion';

function DetailsAccordion({ allergens, desc, ingredients, photoNutrition }) {
    let items = [];

    if (desc) {
        items = [
            ...items,
            {
                id: 'product-description',
                headline: 'Product Description',
                content: <p>{desc}</p>,
            },
        ];
    }

    if (ingredients || allergens) {
        items = [
            ...items,
            {
                id: 'ingredients',
                headline: 'Ingredients',
                content: (
                    <>
                        {ingredients && <p>{ingredients}</p>}
                        {ingredients && allergens && <br />}
                        {allergens && <p className="font-grotesk-bold">{allergens}</p>}
                    </>
                ),
            },
        ];
    }

    if (photoNutrition) {
        items = [
            ...items,
            {
                id: 'nutrients',
                headline: 'Nutrients',
                content: <img alt="nutrition facts" className="w-[800px]" src={photoNutrition} />,
            },
        ];
    }

    return <Accordion type="multiple" defaultValue={['product-description', 'ingredients']} items={items} />;
}

export default DetailsAccordion;

DetailsAccordion.propTypes = {
    allergens: PropTypes.string,
    desc: PropTypes.string,
    ingredients: PropTypes.string,
    photoNutrition: PropTypes.string,
};

DetailsAccordion.defaultProps = {
    allergens: null,
    desc: null,
    ingredients: null,
    photoNutrition: null,
};
